module.exports = __webpack_public_path__ + "img/pd_b1_img4.93460e6a.png";